import React, { useState } from "react";
import { Container, Button, Tabs, Tab, Typography, Stack, IconButton } from "@mui/material";
import { Add, ArrowBack } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import EmailTemplateDialog from "./email-template";
import EmailList from "./email-list";
import SMSTemplateModal from "./sms-template";
import WhatsAppTemplateModal from "./whatsapp-template";
import SmsList from "./sms-list";
import WhatsappList from "./whatsapp-list";

const EmailListPage = () => {
    const [tab, setTab] = useState("email");
    const location = useLocation();
    const navigate = useNavigate();
    const position = location.state?.position;
    const [open, setOpen] = useState(false);

    return (
        <Container maxWidth="md" sx={{ mt: 4 }}>
            {/* Back Button with Title */}
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                <IconButton onClick={() => navigate(-1)}>
                    <ArrowBack />
                </IconButton>
                <Typography variant="h5" fontWeight="bold">
                    Email, SMS & WhatsApp Templates
                </Typography>
            </Stack>

            <Typography color="gray" sx={{ mb: 2 }}>
                Create and edit Email and SMS templates to use them on your candidate notifications.
            </Typography>

            <Tabs value={tab} onChange={(e, newValue) => setTab(newValue)} sx={{ mb: 2 }}>
                <Tab label="Email" value="email" />
                <Tab label="SMS" value="sms" />
                <Tab label="WhatsApp" value="whatsapp" />
            </Tabs>

            <Button
                variant="contained"
                sx={{ mb: 2, backgroundColor: "#1976D2", textTransform: 'none' }}
                startIcon={<Add />}
                onClick={() => setOpen(true)}
            >
                Create a {tab} template
            </Button>

            <Stack mb={2}>
                {tab === 'email' && <EmailList />}
                {tab==="sms" &&<SmsList/>}
                {tab==="whatsapp" &&<WhatsappList/>}


            </Stack>

            {tab === 'email' && <EmailTemplateDialog open={open} onClose={() => setOpen(false)} jobTitle={position?.title} />}
            {tab === 'sms' && <SMSTemplateModal open={open} onClose={() => setOpen(false)} jobTitle={position?.title} />}
            {tab === 'whatsapp' && <WhatsAppTemplateModal open={open} onClose={() => setOpen(false)} jobTitle={position?.title} />}
        </Container>
    );
};

export default EmailListPage;
